// extracted by mini-css-extract-plugin
export default {"boxBrand":"Categories_boxBrand__Q7aub"};